import * as requestFromServer from "./mergingCrud";
import { distributionMergingSlice, callTypes } from "./mergingSlice";
import { actions as auth } from "../../../Auth/_redux/authRedux";
import { toastOption } from "../../../../../_metronic/_helpers/ToastHelpers";
import { toast } from "react-toastify";

const { actions } = distributionMergingSlice;

export const fetchDistributionMergings = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findDistributionMerging(queryParams)
    .then((response) => {
      const { data } = response.data;
      dispatch(actions.distributionMergingsFetched(data));
    })
    .catch((error) => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const submitDistribution = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .submitDistribution(queryParams)
    .then((response) => {
      const { data } = response.data;
      dispatch(actions.distributionMergingReload());
      return data;
    })
    .catch((error) => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
